@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  overflow: hidden;
  grid-template-rows: 1fr max-content;
}

.checkbox {
  // WA to prevent focus take 100%
  // Should ne fixed on a next Mercury version
  inline-size: max-content;
}
